import { z } from 'zod';

export const translateChallengeBodySchema = z.object({
  langs: z.array(z.string()).optional(),
});

export type ITranslateChallengeBody = z.infer<typeof translateChallengeBodySchema>;
